<div class="main-panel">
    <div class="d-flex">
        <div class="d-flex pt-2">
            <div class="h-30p">
                <input
                    type="text"
                    class="form-control text-box-size shadow-sm client-search-input"
                    placeholder="Search"
                    [attr.id]="'gyan-access-textbox'"
                    [attr.data-test]="'gyan-access-textbox'"
                    [(ngModel)]="searchText"
                    (keyup.enter)="SearchList()"
                    (input)="onSearchTextChange()"
                />
                <div
                    class="cursor-pointer clear-icon icon-pos"
                    [attr.id]="'access-clear'"
                    [attr.data-test]="'access-clear'"
                    (click)="clearSearch()"
                    *ngIf="searchText !== ''"
                ></div>
            </div>

            <div class="form-control search-client"></div>

            <div class="cursor-pointer search-term-icon" [attr.id]="'access-search'" [attr.data-test]="'access-search'" (click)="searchAccess()"></div>
        </div>
        <div class="d-flex" class="submit-button pt-2">
            <button
                class="create-button d-flex"
                #createButton
                [attr.id]="'create-access'"
                [attr.data-test]="'create-access'"
                (click)="openAccessCreationForm(AccessCreateAndEditModel)"
            >
                <div class="icon-plus"></div>
                <div class="pl-5p">Create Access</div>
            </button>
        </div>
    </div>

    <div class="table-container">
        <div
            [ngClass]="{
                'height-table-div': accessList?.length == 10,
                'height-table-div-overflow': accessList?.length < 10 && accessList?.length <= 4,
            }"
        >
            <table class="custom-table" [ngClass]="{ 'custom-table-loading': isLoadingData }">
                <thead class="custom-table-head">
                    <tr>
                        <th class="w-25">Name</th>
                        <th class="w-25">Label</th>
                        <th class="w-10p">User Groups</th>
                        <th class="w-15 actions-text">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="accessList?.length > 0 && !isLoadingData">
                        <tr *ngFor="let access of accessList; let i = index" class="h-35p">
                            <td>
                                <div
                                    class="actions-container d-flex"
                                    [ngClass]="{ 'actions-container-position': accessList?.length < 10 || (accessList?.length === 10 && i + 1 > 5) }"
                                >
                                    <div
                                        class="display-ellipsis show-description"
                                        title="{{ access.accessName }}"
                                        [attr.id]="'access-name-' + i"
                                        [attr.data-test]="'access-name-' + i"
                                        (click)="toggleDescription(i, $event, popovers.get(i)!)"
                                        containerClass="custom-popover"
                                        [popover]="activeAccessDesc === i ? popoverContent : ''"
                                        #pop="bs-popover"
                                        placement="right"
                                    >
                                        {{ access.accessName }}
                                    </div>
                                    <ng-template #popoverContent>
                                        <h3 class="show-description-header">Description</h3>
                                        <div class="label-white-space">{{ access.description || 'Not Available' }}</div>
                                    </ng-template>
                                </div>
                            </td>
                            <td>
                                <div class="display-ellipsis" title="{{ access.accessLable }}">
                                    {{ access.accessLable }}
                                </div>
                            </td>
                            <td>
                                <div
                                    class="actions-container d-flex"
                                    [ngClass]="{ 'actions-container-position': accessList?.length < 10 || (accessList?.length === 10 && i + 1 > 5) }"
                                >
                                    <div
                                        class="cursor-pointer"
                                        [attr.id]="'user-group-view' + i"
                                        [attr.data-test]="'user-group-view-' + i"
                                        (click)="toggleList(i, $event)"
                                        *ngIf="access.userGroupLables?.length > 0"
                                        [ngClass]="{ 'icon-active-eye': activeAccessList === i, 'icon-eye': activeAccessList != i }"
                                    ></div>
                                    <div class="display-ellipsis">
                                        {{
                                            access.userGroupLables.length > 0
                                                ? access.userGroupLables.join(', ')
                                                : ('No user group found
                                        ' | truncateWords: 5)
                                        }}
                                    </div>
                                    <div
                                        class="access-popup-position"
                                        [ngClass]="{
                                            'popup-access': accessList?.length === 10 && i + 1 <= 5,
                                            'popup-up-access': accessList?.length < 10 || (accessList?.length === 10 && i + 1 > 5),
                                        }"
                                        *ngIf="activeAccessList === i"
                                    >
                                        <ng-container *ngIf="access.userGroupLables?.length > 0">
                                            <ul *ngFor="let usergrp of access.userGroupLables; let j = index" class="d-flex popup-container label-style">
                                                <li class="label-white-space" [attr.id]="'user-group-' + j" [attr.data-test]="'user-group-' + j">{{ usergrp }}</li>
                                            </ul>
                                        </ng-container>
                                    </div>
                                </div>
                            </td>
                            <td class="actions-text">
                                <div class="actions-container">
                                    <fa-icon
                                        (click)="togglePopup(i, $event)"
                                        [attr.id]="'action-popup-' + i"
                                        [attr.data-test]="'action-popup-' + i"
                                        class="p-1 cursor-pointer d-flex align-items-center align-vertical-item"
                                        [icon]="faEllipsisV"
                                    >
                                    </fa-icon>
                                    <div
                                        *ngIf="activePopupIndex === i"
                                        [ngClass]="{
                                            'popup-menu': !(accessList?.length >= 9 && i >= accessList?.length - 2),
                                            'popup-menu-bottom': accessList?.length >= 9 && i >= accessList?.length - 2,
                                        }"
                                    >
                                        <div
                                            class="d-flex cursor-pointer popup-container"
                                            [attr.id]="'edit-accesss-' + i"
                                            [attr.data-test]="'edit-accesss-' + i"
                                            (click)="editAccess(access, AccessCreateAndEditModel)"
                                        >
                                            <div class="edit-icon"></div>
                                            <div class="popup-item">Edit</div>
                                        </div>
                                        <!-- <div
                                            class="d-flex cursor-pointer popup-container"
                                            [attr.id]="'delete-accesss-' + i"
                                            [attr.data-test]="'delete-accesss-' + i"
                                            (click)="deleteAccesss()"
                                        >
                                            <div class="trash-icon"></div>
                                            <div class="popup-item">Delete</div>
                                        </div> -->
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-container>

                    <tr *ngIf="accessList?.length === 0">
                        <td colspan="5" class="no-user-text">No Access available with searched text</td>
                    </tr>
                    <tr *ngIf="isLoadingData">
                        <td colspan="5" class="text-center text-secondary">
                            <div class="p-1">
                                <div class="d-flex justify-content-center">
                                    <div class="padding-summary">Loading..</div>
                                    <div><img src="../../../assets/gifs/loader_sand.gif" alt="Processing icon" /></div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="display-pagination" [ngClass]="{ 'display-mobile-pagination': isMobile }" *ngIf="!isLoadingData && accessList?.length > 0">
                <div>{{ startItem }} to {{ endItem }} Items of {{ totalItems }}</div>
                <div class="user-pagination pt-2 px-2">
                    <pagination
                        [totalItems]="totalItems"
                        [(ngModel)]="currentPage"
                        [maxSize]="5"
                        class="justify-content-center pagination mb-0 px-0"
                        previousText="&lsaquo;"
                        nextText="&rsaquo;"
                        firstText="&laquo;"
                        lastText="&raquo;"
                        [boundaryLinks]="true"
                        [rotate]="false"
                        (pageChanged)="onPageChanged($event)"
                    >
                    </pagination>
                </div>
            </div>
        </div>
    </div>

    <!-- <div *ngIf="showcreateandEditForm" class="overlay"></div> -->

    <ng-template #AccessCreateAndEditModel let-modal>
        <div>
            <div class="modal-dialog m-0">
                <div class="modal-content text-center">
                    <div class="modal-header fw-600 create-ug-header">
                        <div *ngIf="!disableForm">Create Access</div>
                        <div *ngIf="disableForm">Edit Access</div>
                        <div
                            type="button"
                            class="gyan-popup-close"
                            aria-label="Close"
                            (click)="closeCreateandEditForm()"
                            [attr.id]="'access-modal-close'"
                            [attr.data-test]="'access-modal-close'"
                        >
                            <div class="modal-close-icon"></div>
                        </div>
                    </div>
                    <div class="modal-body ug-form-body">
                        <div class="mb-3">
                            <div class="label-form">Name</div>
                            <div class="ug-name-div">
                                <input
                                    type="text"
                                    class="form-control text-box-size shadow-sm ug-name"
                                    placeholder="Enter Access Name"
                                    [attr.id]="'access-name-textbox'"
                                    [attr.data-test]="'access-name-textbox'"
                                    [(ngModel)]="accessnameText"
                                    [disabled]="disableForm"
                                    (keypress)="restrictInput($event)"
                                    (blur)="validateField('accessnameText')"
                                />
                                <div class="error-message" *ngIf="errors['accessnameText']">
                                    {{ errors['accessnameText'] }}
                                </div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <div class="label-form">Description</div>
                            <div class="ug-desc-div">
                                <input
                                    type="text"
                                    class="form-control text-box-size shadow-sm ug-desc-input"
                                    placeholder="Enter Description"
                                    [attr.id]="'access-description-textbox'"
                                    [attr.data-test]="'access-description-textbox'"
                                    [(ngModel)]="descriptionText"
                                />
                            </div>
                        </div>

                        <div class="mb-3">
                            <div class="label-form">Label</div>
                            <div class="ug-desc-div">
                                <input
                                    type="text"
                                    class="form-control text-box-size shadow-sm ug-desc-input"
                                    placeholder="Enter Label"
                                    [attr.id]="'access-label-textbox'"
                                    [attr.data-test]="'access-label-textbox'"
                                    [(ngModel)]="labelText"
                                    (blur)="validateField('labelText')"
                                />
                                <div class="error-message" *ngIf="errors['labelText']">
                                    {{ errors['labelText'] }}
                                </div>
                            </div>
                        </div>

                        <div class="mb-3">
                            <div class="label-form">User Group</div>
                            <div class="access-dropdown">
                                <app-multi-select-dropdown
                                    id="selectedUserGroup"
                                    class="multi-select-option form-control shadow-sm access-form"
                                    [items]="userGroupList"
                                    [selectedItems]="selectedUserGroupItems"
                                    selectedProp="userGroupId"
                                    displayname="label"
                                    filterByLabel="label"
                                    [selectedCountText]="selectedUserGroupCountText"
                                    [selectedBlankText]="selectedUserGroupBlankText"
                                    (selectedItemsChange)="onSelectionUserGroupChange($event)"
                                    (checkvalidation)="onBlurUsergroup($event)"
                                ></app-multi-select-dropdown>
                            </div>
                            <div class="error-message" *ngIf="errors['selectedUserGroupItems']">
                                {{ errors['selectedUserGroupItems'] }}
                            </div>
                        </div>

                        <div class="mt-3">
                            <div class="d-flex justify-content-end pt-30p">
                                <button
                                    class="create-btn"
                                    *ngIf="!disableForm"
                                    (click)="createNewAccess()"
                                    [disabled]="!isFormValid()"
                                    [attr.id]="'save-access'"
                                    [attr.data-test]="'save-access'"
                                >
                                    Create
                                </button>
                                <button
                                    class="create-btn"
                                    *ngIf="disableForm"
                                    (click)="createNewAccess()"
                                    [disabled]="!isFormValid()"
                                    [attr.id]="'update-access'"
                                    [attr.data-test]="'update-access'"
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                        <!-- </form> -->
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>
